$(".closed-dropdown").on("click", function () {
  $(".closed-dropdown").addClass("hide-communicate");
  $("div:first-child").addClass("no-border-communicate");
  $(".year-month-filter").addClass("show-communicate");
});

$(".hide-dropdown").on("click", function () {
  $(".closed-dropdown").removeClass("hide-communicate");
  $(".year-month-filter").removeClass("show-communicate");
});

$(".checkmark1").on("click", function () {
  $(".checkmark1").addClass("index0-communicate");
  $(".checkmark2").addClass("index0-communicate");
  $(".month-selector-start").addClass("show-month-selector-communicate");
  $(".month-selector-end").removeClass("show-month-selector-communicate");
  $(".all-year-label").addClass("inactive-button-communicate");
  $("#01-end").prop("disabled", false);
  $("#02-end").prop("disabled", false);
  $("#03-end").prop("disabled", false);
  $("#04-end").prop("disabled", false);
  $("#05-end").prop("disabled", false);
  $("#06-end").prop("disabled", false);
  $("#07-end").prop("disabled", false);
  $("#08-end").prop("disabled", false);
  $("#09-end").prop("disabled", false);
  $("#10-end").prop("disabled", false);
  $("#11-end").prop("disabled", false);
  $("#01-end").removeClass("no-cursor-communicate");
  $("#02-end").removeClass("no-cursor-communicate");
  $("#03-end").removeClass("no-cursor-communicate");
  $("#04-end").removeClass("no-cursor-communicate");
  $("#05-end").removeClass("no-cursor-communicate");
  $("#06-end").removeClass("no-cursor-communicate");
  $("#07-end").removeClass("no-cursor-communicate");
  $("#08-end").removeClass("no-cursor-communicate");
  $("#09-end").removeClass("no-cursor-communicate");
  $("#10-end").removeClass("no-cursor-communicate");
  $("#11-end").removeClass("no-cursor-communicate");
});

$(".dropbtn").on("input", function () {
  if (
    document.getElementById("month-text-end").innerText == "Mese" ||
    document.getElementById("month-text-end").innerText == "" ||
    document.getElementById("month-text-start").innerText == "Mese" ||
    document.getElementById("month-text-start").innerText == ""
  ) {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", true);
  } else {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", false);
  }
  $(
    ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
  ).prop("disabled", false);
});

$(".dropbtn").on("mouseleave", function () {
  if (document.getElementsByClassName("dropbtn").filterYear.value == "") {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", true);
  } else {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", false);
  }
});

$(".month-choice-start").on("click", function () {
  $(".month-selector-start").addClass("show-month-selector-communicate");
  $(".month-selector-end").removeClass("show-month-selector-communicate");
});

$(".month-start-text").on("click", function () {
  $(".month-choice-start strong").removeClass("active-month-communicate");
  $(".month-selector-start").removeClass("show-month-selector-communicate");
  $(".checkmark1").removeClass("index0-communicate");
  $(".checkmark2").removeClass("index0-communicate");
  if (
    document.getElementById("month-text-end").innerText == "Mese" ||
    document.getElementById("month-text-end").innerText == ""
  ) {
    $(".all-year-filter").prop("checked", true);
  }
});

$(".checkmark2").on("click", function () {
  $(".checkmark1").addClass("index0-communicate");
  $(".checkmark2").addClass("index0-communicate");
  $(".month-selector-end").addClass("show-month-selector-communicate");
  $(".month-selector-start").removeClass("show-month-selector-communicate");
  $(".all-year-label").addClass("inactive-button-communicate");
  $("#01").prop("disabled", false);
  $("#02").prop("disabled", false);
  $("#03").prop("disabled", false);
  $("#04").prop("disabled", false);
  $("#05").prop("disabled", false);
  $("#06").prop("disabled", false);
  $("#07").prop("disabled", false);
  $("#08").prop("disabled", false);
  $("#09").prop("disabled", false);
  $("#10").prop("disabled", false);
  $("#11").prop("disabled", false);
});

$(".month-end-text").on("click", function () {
  $(".month-choice-end strong").removeClass("active-month-communicate");
  $(".month-selector-end").removeClass("show-month-selector-communicate");
  $(".checkmark1").removeClass("index0-communicate");
  $(".checkmark2").removeClass("index0-communicate");
  if (
    document.getElementById("month-text-start").innerText == "Mese" ||
    document.getElementById("month-text-start").innerText == ""
  ) {
    $(".all-year-filter").prop("checked", true);
  }
});

$(".all-year-filter").on("click", function () {
  $(".month-choice-end strong").removeClass("active-month-communicate");
  $(".month-choice-start strong").removeClass("active-month-communicate");
  $(".month-selector-start").removeClass("show-month-selector-communicate");
  $(".month-selector-end").removeClass("show-month-selector-communicate");
  $(".all-year-label").removeClass("inactive-button-communicate");
  $(".checkmark1").removeClass("index0-communicate");
  $(".checkmark2").removeClass("index0-communicate");
  $("#01-end").prop("disabled", false);
  $("#02-end").prop("disabled", false);
  $("#03-end").prop("disabled", false);
  $("#04-end").prop("disabled", false);
  $("#05-end").prop("disabled", false);
  $("#06-end").prop("disabled", false);
  $("#07-end").prop("disabled", false);
  $("#08-end").prop("disabled", false);
  $("#09-end").prop("disabled", false);
  $("#10-end").prop("disabled", false);
  $("#11-end").prop("disabled", false);
  $("#01").prop("disabled", false);
  $("#02").prop("disabled", false);
  $("#03").prop("disabled", false);
  $("#04").prop("disabled", false);
  $("#05").prop("disabled", false);
  $("#06").prop("disabled", false);
  $("#07").prop("disabled", false);
  $("#08").prop("disabled", false);
  $("#09").prop("disabled", false);
  $("#10").prop("disabled", false);
  $("#11").prop("disabled", false);
});

$(".month-start").on("click", function () {
  $(".month-choice-start strong").addClass("active-month-communicate");
  $(".month-selector-start").removeClass("show-month-selector-communicate");
  $(".checkmark1").removeClass("index0-communicate");
  $(".checkmark2").removeClass("index0-communicate");
  if (
    document.getElementById("month-text-end").innerText == "Mese" ||
    document.getElementById("month-text-end").innerText == "" ||
    document.getElementsByClassName("dropbtn").filterYear.value == ""
  ) {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", true);
  } else {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", false);
  }
});

$(".month-end").on("click", function () {
  $(".month-choice-end strong").addClass("active-month-communicate");
  $(".month-selector-end").removeClass("show-month-selector-communicate");
  $(".checkmark1").removeClass("index0-communicate");
  $(".checkmark2").removeClass("index0-communicate");
  if (
    document.getElementById("month-text-start").innerText == "Mese" ||
    document.getElementById("month-text-start").innerText == "" ||
    document.getElementsByClassName("dropbtn").filterYear.value == ""
  ) {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", true);
  } else {
    $(
      ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
    ).prop("disabled", false);
  }
});

$(".radio-filter").on("click", function () {
  $(".month-filter-start").removeClass("show-filter-communicate");
  $(".month-filter-end").removeClass("show-filter-communicate");
  $(".closed-dropdown").removeClass("hide-communicate");
  $(".year-month-filter").removeClass("show-communicate");
  $(".month-choice-end strong").removeClass("active-month-communicate");
  $(".month-choice-start strong").removeClass("active-month-communicate");
  $(
    ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
  ).prop("disabled", true);
  $(".all-year-filter").prop("checked", true);
  $(".show-dropdown").removeClass("hide-communicate");
  $(".radio-filter-label").removeClass("inactive-button-communicate");
});

$("#01").on("click", function () {
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 1;
});
$("#02").on("click", function () {
  $("#01-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 2;
  $("#01-end").addClass("no-cursor-communicate");
});
$("#03").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 3;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
});
$("#04").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 4;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
});
$("#05").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 5;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
});
$("#06").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 6;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
});
$("#07").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 7;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
});
$("#08").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  $("#07-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 8;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
  $("#07-end").addClass("no-cursor-communicate");
});
$("#09").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  $("#07-end").prop("disabled", true);
  $("#08-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 9;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
  $("#07-end").addClass("no-cursor-communicate");
  $("#08-end").addClass("no-cursor-communicate");
});
$("#10").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  $("#07-end").prop("disabled", true);
  $("#08-end").prop("disabled", true);
  $("#09-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 10;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
  $("#07-end").addClass("no-cursor-communicate");
  $("#08-end").addClass("no-cursor-communicate");
  $("#09-end").addClass("no-cursor-communicate");
});
$("#11").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  $("#07-end").prop("disabled", true);
  $("#08-end").prop("disabled", true);
  $("#09-end").prop("disabled", true);
  $("#10-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 11;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
  $("#07-end").addClass("no-cursor-communicate");
  $("#08-end").addClass("no-cursor-communicate");
  $("#09-end").addClass("no-cursor-communicate");
  $("#10-end").addClass("no-cursor-communicate");
});
$("#12").on("click", function () {
  $("#01-end").prop("disabled", true);
  $("#02-end").prop("disabled", true);
  $("#03-end").prop("disabled", true);
  $("#04-end").prop("disabled", true);
  $("#05-end").prop("disabled", true);
  $("#06-end").prop("disabled", true);
  $("#07-end").prop("disabled", true);
  $("#08-end").prop("disabled", true);
  $("#09-end").prop("disabled", true);
  $("#10-end").prop("disabled", true);
  $("#11-end").prop("disabled", true);
  document.getElementsByClassName("month-start-value")[
    "month-start-value"
  ].value = 12;
  $("#01-end").addClass("no-cursor-communicate");
  $("#02-end").addClass("no-cursor-communicate");
  $("#03-end").addClass("no-cursor-communicate");
  $("#04-end").addClass("no-cursor-communicate");
  $("#05-end").addClass("no-cursor-communicate");
  $("#06-end").addClass("no-cursor-communicate");
  $("#07-end").addClass("no-cursor-communicate");
  $("#08-end").addClass("no-cursor-communicate");
  $("#09-end").addClass("no-cursor-communicate");
  $("#10-end").addClass("no-cursor-communicate");
  $("#11-end").addClass("no-cursor-communicate");
});

$("#12-end").on("click", function () {
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 12;
});
$("#11-end").on("click", function () {
  $("#12").prop("disabled", true);
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 11;
});
$("#10-end").on("click", function () {
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 10;
});
$("#09-end").on("click", function () {
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 9;
});
$("#08-end").on("click", function () {
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 8;
});
$("#07-end").on("click", function () {
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 7;
});
$("#06-end").on("click", function () {
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 6;
});
$("#05-end").on("click", function () {
  $("#06").prop("disabled", true);
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#06").addClass("no-cursor-communicate");
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 5;
});
$("#04-end").on("click", function () {
  $("#05").prop("disabled", true);
  $("#06").prop("disabled", true);
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#05").addClass("no-cursor-communicate");
  $("#06").addClass("no-cursor-communicate");
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 4;
});
$("#03-end").on("click", function () {
  $("#04").prop("disabled", true);
  $("#05").prop("disabled", true);
  $("#06").prop("disabled", true);
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#04").addClass("no-cursor-communicate");
  $("#05").addClass("no-cursor-communicate");
  $("#06").addClass("no-cursor-communicate");
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 3;
});
$("#02-end").on("click", function () {
  $("#03").prop("disabled", true);
  $("#04").prop("disabled", true);
  $("#05").prop("disabled", true);
  $("#06").prop("disabled", true);
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#03").addClass("no-cursor-communicate");
  $("#04").addClass("no-cursor-communicate");
  $("#05").addClass("no-cursor-communicate");
  $("#06").addClass("no-cursor-communicate");
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 2;
});
$("#01-end").on("click", function () {
  $("#02").prop("disabled", true);
  $("#03").prop("disabled", true);
  $("#04").prop("disabled", true);
  $("#05").prop("disabled", true);
  $("#06").prop("disabled", true);
  $("#07").prop("disabled", true);
  $("#08").prop("disabled", true);
  $("#09").prop("disabled", true);
  $("#10").prop("disabled", true);
  $("#11").prop("disabled", true);
  $("#12").prop("disabled", true);
  $("#02").addClass("no-cursor-communicate");
  $("#03").addClass("no-cursor-communicate");
  $("#04").addClass("no-cursor-communicate");
  $("#05").addClass("no-cursor-communicate");
  $("#06").addClass("no-cursor-communicate");
  $("#07").addClass("no-cursor-communicate");
  $("#08").addClass("no-cursor-communicate");
  $("#09").addClass("no-cursor-communicate");
  $("#10").addClass("no-cursor-communicate");
  $("#11").addClass("no-cursor-communicate");
  $("#12").addClass("no-cursor-communicate");
  document.getElementsByClassName("month-end-value")[
    "month-end-value"
  ].value = 1;
});

$(
  ".page-template-service .service-detail-page .service-accordion .filter .year-month-filter .confirm"
).prop("disabled", true);
